const RESOURCE_ACCENT_PALETTE = [
    '#f37037',
    '#277da1',
    '#43aa8b',
    '#6d597a',
    '#bc4749',
    '#577590',
    '#9c6644',
    '#4361ee',
    '#2a9d8f',
    '#ef476f',
    '#8f5cf7',
    '#4d908e'
];

const UNASSIGNED_RESOURCE_COLOR = '#8d99ae';

const hashString = (value: string): number => {
    let hash = 0;
    for (let index = 0; index < value.length; index += 1) {
        hash = ((hash << 5) - hash) + value.charCodeAt(index);
        hash |= 0;
    }
    return Math.abs(hash);
};

const getResourceAccentColor = ({ resourceId, title, index }: { resourceId?: string | null; title?: string | null; index?: number | null; }): string => {
    if (!resourceId || resourceId === '0') {
        return UNASSIGNED_RESOURCE_COLOR;
    }

    if (typeof index === 'number' && Number.isFinite(index)) {
        return RESOURCE_ACCENT_PALETTE[Math.abs(index) % RESOURCE_ACCENT_PALETTE.length];
    }

    const stableKey = `${resourceId}|${title ?? ''}`;
    return RESOURCE_ACCENT_PALETTE[hashString(stableKey) % RESOURCE_ACCENT_PALETTE.length];
};

const getResourceInitials = (title?: string | null): string => {
    const parts = String(title ?? '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);

    if (!parts.length) {
        return '?';
    }

    return parts
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
};

export { RESOURCE_ACCENT_PALETTE, UNASSIGNED_RESOURCE_COLOR, getResourceAccentColor, getResourceInitials };
